module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab14/awsop-lab14.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab14/awsop-lab14.component.css
// module chunks = main